<template>
    <div :class="['visual-floor', {'is-show': isReady}]">
        <Canvas>
          <Pointer :isMobileHorizontal="isMobileHorizontal" slot="pointer"/>
          <FakePointer :isMobileHorizontal="isMobileHorizontal" slot="fakePointer"/>
        </Canvas>
        <Filters/>
        <Rotate @change="onRotateChange"/>
    </div>
</template>

<style lang="scss">
    @import "./Floor.scss";
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
import Canvas from '../../components/Canvas/Canvas';
import Filters from '../../components/Filters/Filters';
import Pointer from '../../components/Pointer/Pointer';
import Rotate from '../../components/Rotate/Rotate';
import store from '../../store';
import FakePointer from "@/components/FakePointer/FakePointer.vue";

export default {
    props: {
        isMobileHorizontal: Boolean
    },

    components: {
        FakePointer,
        Pointer,
        Canvas,
        Filters,
        Rotate
    },

    computed: {...mapGetters({isReady: 'GET_IS_READY'})},

    beforeRouteEnter(to, from, next) {
        /**
         * Отправляет данные на сервер.
         */
        const body = {
            step    : 'floor',
            complex : to.params.complexId || false,
            building: to.params.buildingId,
            ...to.params
        };
        const resetForm = to.hash === '#breadcrumb';

        store.dispatch('send', {
            body,
            resetForm,
            query: to.query
        }).then(() => {
            next();
        });

        if (to.query.localhost) {
            fetch('http://localhost/vvvv?0');
        }
    },

    methods: {
        ...mapActions(['send']),

        onRotateChange() {
            /* Отправка запроса при смене ракурса */
            const body = {
                step    : 'floor',
                complex : this.$route.params.complexId || false,
                building: this.$route.params.buildingId,
                ...this.$route.params
            };

            this.send({
                body,
                resetForm: false,
                query    : this.$route.query
            });
        }
    }
};
</script>
